import './CandidatePortal.css';

const JOBS = [
  { id:'PRODUCT-MANA-AHFAWU', title:'Product Manager', dept:'Product', loc:'India', mode:'Remote', salary:'₹10–18 LPA', posted:'02 Jul 2026' },
  { id:'TALENT-ACQUI-81EED5', title:'Talent Acquisition', dept:'HR', loc:'India', mode:'Remote', salary:'₹5–10 LPA', posted:'02 Jul 2026' },
  { id:'PROD-00240-2026',     title:'Product Manager 26', dept:'Product', loc:'India', mode:'Remote', salary:'₹8–12 LPA', posted:'02 Jul 2026' },
];

const WHY_ITEMS = [
  { icon:'📈', title:'Career Growth',      desc:'Continuous learning opportunities and clear advancement paths.' },
  { icon:'🌍', title:'Global Impact',      desc:'Work on projects that reach millions of users worldwide.' },
  { icon:'❤️', title:'Work-Life Balance',  desc:'Flexible schedules, remote work options, and comprehensive benefits.' },
  { icon:'🏆', title:'Recognition',        desc:'Performance-based bonuses and employee recognition programs.' },
];

const HOW = [
  { icon:'👤', title:'Create Profile',  desc:'Highlight your skills, experience, and career goals in minutes.' },
  { icon:'📋', title:'Validate Skills', desc:'Take role-based assessments that recruiters trust. No stress.' },
  { icon:'🤝', title:'Get Matched',     desc:'AI connects you with jobs that match your exact skills.' },
  { icon:'🚀', title:'Apply & Grow',    desc:'Apply confidently, track progress, and land your dream role.' },
];

export default function CandidatePortal() {
  return (
    <section id="candidate" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow eyebrow--green">Candidate Portal</span>
        <h2 className="sec-title">Your Career Journey, Simplified.</h2>
        <p className="sec-sub" style={{marginBottom:'3rem'}}>
          The VERDICT Candidate Portal gives talent a clean, transparent way to find
          roles, validate skills, and track their journey — from first assessment to final offer.
        </p>

        {/* Job listings mockup */}
        <div className="candidate-showcase">
          <div className="jobs-panel">
            <div className="jobs-panel__header">
              <h3 className="jobs-panel__title">Find Your Perfect Role</h3>
              <span className="jobs-panel__count">36 roles available</span>
            </div>
            <div className="jobs-search">🔍 Search by role, department, location…</div>
            <div className="jobs-filters">
              <span className="jf-pill">All Departments ▾</span>
              <span className="jf-pill">All Work Modes ▾</span>
              <span className="jf-pill">All Locations ▾</span>
            </div>
            <div className="job-cards">
              {JOBS.map(j => (
                <div key={j.id} className="job-card">
                  <div className="job-card__top">
                    <span className="job-card__id"># {j.id}</span>
                    <span className="job-card__mode">{j.mode}</span>
                  </div>
                  <div className="job-card__title">{j.title}</div>
                  <div className="job-card__meta">
                    <span>🏢 {j.dept}</span>
                    <span>📍 {j.loc}</span>
                  </div>
                  <div className="job-card__tags">
                    <span className="jc-tag">Full-time</span>
                    <span className="jc-tag jc-tag--green">💰 {j.salary}</span>
                  </div>
                  <div className="job-card__footer">
                    <span className="jc-posted">Posted: {j.posted}</span>
                    <div className="jc-actions">
                      <button className="jc-btn jc-btn--apply">Apply Now</button>
                      <button className="jc-btn jc-btn--details">Details</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="candidate-right">
            {/* Why join */}
            <div className="why-join">
              <h4 className="why-join__title">Why Join Us?</h4>
              <div className="why-join__grid">
                {WHY_ITEMS.map(w => (
                  <div key={w.title} className="why-card">
                    <div className="why-card__icon">{w.icon}</div>
                    <div className="why-card__title">{w.title}</div>
                    <div className="why-card__desc">{w.desc}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* How it works for candidates */}
            <div className="cand-how">
              <h4 className="cand-how__title">How it works</h4>
              {HOW.map((h, i) => (
                <div key={h.title} className="cand-how-step">
                  <div className="chs-num">{i+1}</div>
                  <div className="chs-icon">{h.icon}</div>
                  <div>
                    <div className="chs-title">{h.title}</div>
                    <div className="chs-desc">{h.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
